// extracted by mini-css-extract-plugin
export default {"article":"textarea_article__HWulX","error":"textarea_error__Y2Pkr"};